import React from 'react';
import { Stack, Text } from '@fluentui/react';
import { getDisplayName } from 'components/util';
import { QueueConfiguration } from 'services';

const maxTitleWidth = { root: { maxWidth: 'calc(100% - 20px)' } };

export const DashCardTitle: React.FunctionComponent<{ config: QueueConfiguration }> = props => {
  return (
    <Stack horizontal verticalAlign="center">
      <Stack.Item align="center" styles={maxTitleWidth}>
        <Text as={'h2'} variant="xLargePlus" nowrap>
          {getDisplayName(props.config.subjectType, props.config.displayName)}
        </Text>
      </Stack.Item>
    </Stack>
  );
};

export default DashCardTitle;
